import { render } from "./TaskDropDown.vue?vue&type=template&id=0a053a36"
import script from "./TaskDropDown.vue?vue&type=script&lang=js"
export * from "./TaskDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__